/**
 * <cmp-filters-toggle> wraps the "Filtri" button above a collection with vertical filters.
 * Toggles <html data-cmp-filters="closed"> (outside the section, so it survives Horizon's
 * section re-render after filtering) and remembers the choice in localStorage.
 * CSS hides the pane and the grid switches to the "filters closed" column count.
 */
const STORAGE_KEY = 'cmp-filters';

function isClosed() {
  return document.documentElement.dataset.cmpFilters === 'closed';
}

class CmpFiltersToggle extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', this.#toggle);
    this.#sync();
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.#toggle);
  }

  #sync() {
    this.button?.setAttribute('aria-expanded', String(!isClosed()));
  }

  #toggle = () => {
    const closed = !isClosed();
    if (closed) {
      document.documentElement.dataset.cmpFilters = 'closed';
    } else {
      delete document.documentElement.dataset.cmpFilters;
    }
    try {
      localStorage.setItem(STORAGE_KEY, closed ? 'closed' : 'open');
    } catch {
      /* storage unavailable: the toggle still works for this page */
    }
    this.#sync();
  };
}

if (!customElements.get('cmp-filters-toggle')) {
  customElements.define('cmp-filters-toggle', CmpFiltersToggle);
}
